import React from 'react';
import { getAppBranding } from '../config/portalMode';

const Logo = ({ size = 18, className = '' }) => {
    const branding = getAppBranding();
    return (
        <img 
            src={branding.logoPath}
            alt={`${branding.name} Logo`}
            width={size} 
            height={size}
            className={className}
            style={{ objectFit: 'contain' }}
            onError={(e) => {
                if (e.target.src.endsWith('.png') && !e.target.dataset.triedSvg) {
                    e.target.dataset.triedSvg = 'true';
                    e.target.src = branding.logoPath.replace('.png', '.svg');
                } else if (e.target.src.endsWith('.svg') && !e.target.dataset.triedPng) {
                    e.target.dataset.triedPng = 'true';
                    e.target.src = branding.logoPath.replace('.svg', '.png');
                } else {
                    e.target.style.display = 'none';
                }
            }}
        />
    );
};

export default Logo;

